import React from 'react';
import styles from '../styles/all-scores-container.module.scss';
import {ScoresPlaceholder} from "../../../core/components/scores-placeholders/placeholder/scores.placeholder";
import {DeviceViewModel} from "../../../core/models/device.view-model";
import {AppSettings} from "../../../core/app/models/app-settings";
import {LoadingIndicator} from "../../../core/components/loading/loading-indicator";
import {UseIoC} from "../../../core/components/composers/composer-plugins/use-ioc";

export const AllScoresContainerPlaceholder = UseIoC()((props) => {
  const device = props.ioc.getInstance(DeviceViewModel);
  const appSettings = props.ioc.getInstance(AppSettings);

  return (
    device.isSmallView || appSettings.isWidget ? <ScoresPlaceholder/> : <div
      className={[styles.all_scores_container]}><LoadingIndicator/></div>
  )
});
